// Porteo directo de Campo en sigte-prototipo.jsx:562-570 (mismo input, mismas
// clases). Compartido por Clientes/Edificios/Equipos/Catalogos para no repetir
// el mismo bloque en cada archivo, igual que el prototipo lo comparte una vez.
export function Campo(p) {
  return (
    <div className={p.className || ""}>
      <label className="mb-1 block text-xs font-medium text-neutral-500">{p.label}</label>
      <input type={p.type || "text"} value={p.value} onChange={function (e) { p.onChange(e.target.value); }}
        placeholder={p.placeholder} onKeyDown={p.onKeyDown}
        className="w-full rounded-lg border border-neutral-200 bg-white px-3 py-2 text-sm text-neutral-900 placeholder-neutral-400 focus:border-neutral-400 focus:outline-none"/>
    </div>
  );
}
